/**
 * Created by Jie Gao on 2019-09-30.
 */
import {
    IdleAnimationConfig,
    IdleAnimationController
} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {DragonTribeGameModuleConfig} from "../DragonTribeGameModuleConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class BackgroundIdleAnimation extends IdleAnimationController {
    protected _betWinsData:IBetWinData[] | null;
    constructor(config?:IdleAnimationConfig) {
        super(config);
    }

    protected  onGameDataParsed(data:ParsedGameData):void{
        this._betWinsData = data.betWins;
    }

    protected  hasWin():boolean{
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected playIdleAnimation():void {
        DragonTribeGameModuleConfig.background.playDragonFlyAnimation();
    }
}